import {combineReducers} from 'redux';
import orderPackages from './OrderPackages/reducer';

export default combineReducers({
    orderPackages,
});
